import * as React from "react";
import { EngagementConfiguration } from "../types";
import Header from "./Header";
import ConfigContext from "../context/ConfigContext";

interface ConfigExtension {
  config: EngagementConfiguration;
}

interface CallHeaderProps {
  agentName: string;
  agentHeadshotUrl: string;
  isPopout: boolean;
  onPopout: () => void;
  onCollapse: () => void;
  onClose: () => void;
}

class CallHeader extends React.Component<
  CallHeaderProps & ConfigExtension,
  {}
> {
  render() {
    return (
      <Header
        isPopout={this.props.isPopout}
        onClose={this.props.onClose}
        onCollapse={this.props.onCollapse}
        onPopout={this.props.onPopout}
        headerContent={
          <React.Fragment>
            <div className="velaro-header-headshot">
              <img
                src={this.props.agentHeadshotUrl}
                alt={`${this.props.agentName} profile`}
              />
            </div>
            <div className="velaro-header-agent-name velaro-text-primary">
              {this.props.agentName}
            </div>
          </React.Fragment>
        }
      />
    );
  }
}

export default (props: CallHeaderProps) => (
  <ConfigContext.Consumer>
    {config => <CallHeader config={config} {...props} />}
  </ConfigContext.Consumer>
);
